define('viewModels/privileged/qm/util/BroadCastEnum',[], function () {
    'use strict';

    return {
        "HANDLE_EMAIL_EVALUATION_TOPIC": "handleEmailEvaluation",
        "ACTIVATED_EVALUATION": "activatedEvaluation",
        "USER_IMAGES_AVAILABLE": "userImagesAvailable"
    };
});

